export const COMPANIES_SET_DATA_LOADING_STATE = 'COMPANIES_SET_DATA_LOADING_STATE';
export const COMPANIES_SET_REQUEST_LOADING_STATE = 'COMPANIES_SET_REQUEST_LOADING_STATE';
export const COMPANIES_SET_LOADING_STATE = 'COMPANIES_SET_LOADING_STATE';
export const COMPANIES_SET_ERROR = 'COMPANIES_SET_ERROR';
export const COMPANIES_RESET_ERROR = 'COMPANIES_RESET_ERROR';
export const COMPANIES_SET_COMPANY_DATA = 'COMPANIES_SET_COMPANY_DATA';
